import { createAction, props } from '@ngrx/store';

import * as models from '../../domain/models';

export const load = createAction('[TaskMgmt.AircraftInspectionCollection] Load');
export const loadSuccess = createAction(
  '[TaskMgmt.AircraftInspectionCollection] Load Success',
  props<{ payload: Array<models.AircraftInspection> }>()
);
export const loadFail = createAction('[TaskMgmt.AircraftInspectionCollection] Load Fail');
